import Transformer from './../transformer'
import { assetURL, objectToForm } from '@/utils'

const phoneString2Number = (cellphone) =>
  cellphone ? parseInt(`${cellphone}`.replace(' ', '')) : ''


const fetchAddress = function (address) {
  if (typeof address !== 'object') {
    return {}
  }
  return {
    state: address.state.id,
    municipality: address.municipality.id,
    street: address.street,
    noInt: address.no_int,
    noExt: address.no_ext,
    latitude: address.latitude,
    longitude: address.longitude,
    colony: address.colony,
    postalCode: address.postal_code
  }
}

const sendAddress = function (address) {
  if (typeof address !== 'object') {
    address = {}
  }
  return {
    state: address.state,
    municipality: address.municipality,
    street: address.street,
    no_int: address.noInt,
    no_ext: address.noExt,
    latitude: address.latitude,
    longitude: address.longitude,
    colony: address.colony,
    postal_code: address.postalCode
  }
}

export default class CustomerTransformer extends Transformer {
  static fetch(customer) {
    const fiscalData = typeof customer.fiscal_data === 'object' ? customer.fiscal_data : {}
    const contactData = typeof customer.contact_data === 'object' ? customer.contact_data : {}

    let customerType = customer.customer_type
    customerType = {
      id: customerType.id || customerType.customer_type_id,
      name: customerType.name || customerType.customer_type_name
    }

    return {
      id: customer.id,
      name: customer.name,
      codename: customer.codename,
      asentamiento: customer.asentamiento,
      contactData: {
        phone: contactData.phone,
        phoneExt: contactData.phone_ext,
        cellphone: phoneString2Number(contactData.cellphone),
        address: fetchAddress(contactData.address),
        alternativeEmail: contactData.alternative_email,
      },
      fiscalData: {
        bank: fiscalData.bank,
        wayToPay: fiscalData.way_to_pay,
        fiscalAddress: fetchAddress(fiscalData.fiscal_address),
        paymentMethod: fiscalData.payment_method,
        bussinessName: fiscalData.business_name,
        rfc: fiscalData.rfc,
        account: fiscalData.account,
        clabe: fiscalData.clabe
      },
      logo: assetURL(customer.logo),
      customerType,
      customerTypeId: customerType.id,
      customerTypeName: customerType.name
    }
  }

  static send(customer) {
    const fiscalData = customer.fiscalData
    const contactData = customer.contactData

    const serialized = {
      id: customer.id,
      name: customer.name,
      asentamiento: customer.asentamiento,
      codename: customer.codename,
      customer_type: customer.customerTypeId,
      contact_data: {
        phone: contactData.phone,
        phone_ext: contactData.phoneExt,
        cellphone: phoneString2Number(contactData.cellphone),
        address: sendAddress(contactData.address),
        alternative_email: contactData.alternativeEmail,
      },
      fiscal_data: {
        bank: fiscalData.bank,
        way_to_pay: fiscalData.wayToPay,
        fiscal_address: sendAddress(fiscalData.fiscalAddress),
        payment_method: fiscalData.paymentMethod,
        business_name: fiscalData.bussinessName,
        rfc: fiscalData.rfc,
        account: fiscalData.account,
        clabe: fiscalData.clabe
      }
    }

    const logo = customer.logo
    if (logo !== undefined &&
      (typeof logo !== 'string' || logo.startsWith('data:image'))) {
      serialized.logo = logo || ''
    }

    return serialized
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/customer.js